import { render } from "./SideBar.vue?vue&type=template&id=3c4d8e2c&scoped=true&ts=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=3c4d8e2c&lang=scss&scoped=true"
import "./SideBar.vue?vue&type=style&index=1&id=3c4d8e2c&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4d8e2c"]])

export default __exports__